import { ErrorTranslations } from "../models/error-translaction-model"

export const ptBR: ErrorTranslations = {
  required: "*Preenchimento obrigatório",
  validateNoQuotes: "As aspas simples e as aspas duplas não são permitidas",
  ruleNameRequired: "Nome da Regra é um campo obrigatório",
};
